// extracted by mini-css-extract-plugin
export default {"backButton":"BackButton-module__backButton","backIcon":"BackButton-module__backIcon"};